const COOKIE_EXPIRATION_DAYS = 7; // Default cookie expiration in days
const store = window.sessionStorage;

// Session Storage utilities
export const getStorage = key => JSON.parse(store.getItem(key));

export const setStorage = (key, value) => store.setItem(key, JSON.stringify(value));

export const removeStorage = key => store.removeItem(key);

export const clearAllStorage = () => store.clear();

export const hasStorage = key => {
    const item = getStorage(key);
    return !!item;
}

// Cookie utilities
export const setCookie = (name, value, expiryDate) => {
    let expires;
    if (expiryDate) {
        expires = new Date(expiryDate);
    } else {
        expires = new Date();
        expires.setTime(expires.getTime() + (COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000)); // Add 7 days
    }
    const cookieValue = encodeURIComponent(typeof value === 'string' ? value : JSON.stringify(value));
    document.cookie = `${name}=${cookieValue}; expires=${expires.toUTCString()}; path=/`;
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.indexOf(nameEQ) === 0) {
            const value = cookie.substring(nameEQ.length);
            try {
                return JSON.parse(value);
            } catch (e) {
                return value;
            }
        }
    }
    return null;
};

export const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};